import React, { useEffect, useRef, useState } from "react";
import {
    Input,
    InputGroup,
    InputGroupText,
    Button,
} from "reactstrap";

import leftarrow from "assets/icon/left-arrow.svg";
import Expand from "assets/icon/Expand.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Send from "assets/icon/Send.svg";
import { Formik } from "formik";
import { set } from "lodash";
import { use } from "react";
import kareem from "assets/icon/kareem-icon.svg";
import claire from "assets/icon/claire-icon.svg";
import clairebot from "assets/icon/claire-bot-icon.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toast } from "react-toastify";


const ChatbotSearch = (prop) => {
    const {
        onOrgChange,
        isRendered,
        isTogglingPosition,
        setIsRendered,
        setIsTogglingPosition,
        onClick,
        showChatboat,
        chatbotOpen,
        setChatbotOpen,
        feedmsg,
        setFeedmsg,
        handelSubmit,
        setShowSearch,
        showSearch,
        chathistory,
        chatNameheader,
        getChathistory,
        displayChatHistory,
        selectedOrg,
        orgData,
        showchat
        // handleKeyUp

    } = prop;
    const [isExpanded, setIsExpanded] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);
    const [showPrompts, setShowPrompts] = useState(false);
    const inputRef = useRef(null);
    const textboxRef = useRef(null);
    // console.log("showSearch", showSearch);
    const tooltipTimeoutRef = useRef(null);
    const [tryFeedUpdate, setTryFeedUpdate] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(true);
    /* proactive tooltip*/
    // const getTooltipStorageKey = () => {
    //     const { profile } = JSON.parse(localStorage.getItem("pharmaforce"));
    //     return `tooltip_count_${profile.username}`;

    // };
    /* proactive tooltip*/

    useEffect(() => {
        if (!chatbotOpen && !showchat) {
            setShowSearch(true);
        }
        /* proactive tooltip */
        // debugger;
        // const storageKey = getTooltipStorageKey();
        // const shownCount = parseInt(localStorage.getItem(storageKey)) || 0;
        // if (orgData.length == 1 || selectedOrg.tenantID !== undefined) {
        //     if (shownCount < 1) {
        //         tooltipTimeoutRef.current = setTimeout(() => {
        //             setShowTooltip(true);
        //             localStorage.setItem(storageKey, shownCount + 1);
        //         }, 1000);

        //     }
        // }
        /* proactive tooltip*/

        return () => {
            clearTimeout(tooltipTimeoutRef.current);
        };

    }, [orgData, selectedOrg]);

    const predefinedPrompts = [
        "Generate a report for full financial health",
        "Find negative accumulations",
        "This will be the 3rd prompt for user",
        "Generate a report of all transactions",
        "Generate a report of income through replinished claims only",
    ];


    // console.log(getChathistory.filter((item) => item.date == "Today"))

    const handleClickOutside = (event) => {

        if (textboxRef.current && !event.target.closest('.footer-content')) {
            setIsExpanded(false);
            setShowPrompts(false);
        }

    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handelClick = (e) => {
        // debugger;
        const text = e.target.value;
        setFeedmsg(text);
        setShowSearch(true);
        // handleKeyUp();
    };
    // const msg = "List all of the ways that Claire can help a user manage their contract pharmacy program based on his tools and capabilities. Include some example prompts for each.";
    const orgSelected = selectedOrg.organizationID
    /* proactive tooltip*/
    // const tryFeed = () => {
    //     // debugger;
    //     if (orgSelected || orgData.length === 1) {
    //         clearTimeout(tooltipTimeoutRef.current);

    //         const storageKey = getTooltipStorageKey();
    //         const shownCount = parseInt(localStorage.getItem(storageKey)) || 0;

    //         localStorage.setItem(storageKey, shownCount + 2);

    //         // setFeedmsg(msg);
    //         // setTryFeedUpdate(true);
    //         onClick();
    //         // setIsExpanded(true);
    //         setShowTooltip(false);
    //         setShowSearch(false);
    //     }
    //     else {
    //         toast.success("Select an organization to start using Claire")
    //     }

    // }
    /* proactive tooltip*/
    const handlePrompt = (index) => {
        const promptText = predefinedPrompts[index];
        setFeedmsg(promptText);
        setTryFeedUpdate(true);
        onClick();
        setShowSearch(false);
    }

    useEffect(() => {
        if (tryFeedUpdate && feedmsg) {
            handelSubmit();
            setTryFeedUpdate(false);
        }
    }, [tryFeedUpdate, feedmsg]);

    // useEffect(() => {
    //     if (feedmsg && ) {
    //         handelSubmit();
    //     }
    // }, [feedmsg]);
    const onHandleClick = () => {
        if (feedmsg.length > 0) {
            onClick()
            handelSubmit()
            // setChatbotOpen(true);
            setShowSearch(false);
            // handleKeyUp();

        }

    }


    useEffect(() => {
        if (orgData.length == 1 || selectedOrg.tenantID !== undefined) {
            // debugger;
            setIsReadOnly(false);
        }
    }, [])
    useEffect(() => {
        if (orgData.length == 1 || selectedOrg.tenantID !== undefined) {
            chathistory();
        }
    }, [orgData, selectedOrg]);

    // const historyData = getChathistory.filter((item) => item.date == "Today")
    // const historyChatName = historyData.map((item) => item.chat_names[0].name)

    const modelOpen = () => {
        if (orgData.length == 1 || selectedOrg.tenantID !== undefined) {
            onClick();
            // getchat();
            //chathistory();
            setShowSearch(false);
            setIsExpanded(false);
        }
    };
    // console.log(displayChatHistory)
    const handleKeyUp = (e) => {
        if (e.keyCode == 13 && e.shiftKey) {
            e.preventDefault();
            setFeedmsg((prevText) => prevText + "\n");
        } else if (e.keyCode == 13 && !e.shiftKey) {
            e.preventDefault();
            onHandleClick();
            setIsExpanded(false);
        }
    };

    const expandText = () => {
        if (orgData.length == 1 || selectedOrg.tenantID !== undefined) {
            setIsExpanded(true);
            setIsReadOnly(false);
            setShowPrompts(true);

        }

    }

    return (
        <>
            {
                !showSearch && !showChatboat ? (
                    ""
                ) : (

                    <footer>
                        <div className={`footer-content ${isExpanded ? 'expanded' : ''}`}>
                            <Formik>
                                <div style={{ position: "relative" }}>
                                    <InputGroup>
                                        <InputGroupText className="kareemIcon">
                                            <OverlayTrigger
                                                overlay={(props) => (
                                                    <Tooltip {...props}>Ask Claire</Tooltip>
                                                )}
                                                placement="bottom"
                                            >
                                                <img src={claire} alt="Claire icon" style={{ cursor: "pointer" }} />
                                            </OverlayTrigger>
                                        </InputGroupText>


                                        <OverlayTrigger
                                            overlay={(props) => (
                                                <Tooltip {...props} className={(orgData.length == 1 || selectedOrg.tenantID !== undefined) ? "hideTooltip" : 'tooltipInfo'}>
                                                    {(selectedOrg.tenantID === undefined && orgData.length !== 1) && "Select an cover entity to start using Claire"} </Tooltip>
                                            )}
                                            placement="bottom"


                                        >
                                            <Input type="text" placeholder="Ask Claire"
                                                className={` footer-input ${(orgData.length == 1 || selectedOrg.tenantID !== undefined) ? "" : "send-notallowed"}`}
                                                innerRef={inputRef}
                                                onKeyDown={(e) => handleKeyUp(e)}
                                                onChange={(e) => handelClick(e)}
                                                onClick={expandText}
                                                ref={textboxRef}
                                                value={feedmsg}
                                                readOnly={isReadOnly}
                                            />
                                        </OverlayTrigger>
                                        <InputGroupText>

                                            <OverlayTrigger
                                                overlay={(props) => (
                                                    <Tooltip {...props}>
                                                        {
                                                            selectedOrg.tenantID === undefined && orgData.length !== 1 ? "Select an cover entity to start using Claire" : "Search"
                                                        }
                                                    </Tooltip>
                                                )}
                                                placement="bottom"
                                            >
                                                <img src={Send} alt="Send"
                                                    className={feedmsg.length > 0 ? "send-icon" : "send-notallowed"}
                                                    onClick={onHandleClick} />
                                            </OverlayTrigger>
                                            {/* <span className="send-icon" onClick={onHandleClick} style={{ cursor: "pointer" }}>
                                            
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M3.33301 8H12.6663" stroke="#702C62" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M8 3.33398L12.6667 8.00065L8 12.6673" stroke="#702C62" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                        </span> */}
                                            <OverlayTrigger
                                                overlay={(props) => (
                                                    <Tooltip {...props}>
                                                        {
                                                            selectedOrg.tenantID === undefined && orgData.length !== 1 ? "Select an cover entity to start using Claire" : "Expand Chat"
                                                        }
                                                    </Tooltip>
                                                )}
                                                placement="bottom"
                                            >
                                                <img src={Expand} alt="Expand" onClick={modelOpen} className={` ms-3 ${(orgData.length == 1 || selectedOrg.tenantID !== undefined) ? "send-icon" : "send-notallowed"}`} />
                                            </OverlayTrigger>


                                        </InputGroupText>
                                    </InputGroup >
                                    {/* proactive tooltip
                                    {
                                        showTooltip && (
                                            <>
                                                <div
                                                    className="chatbot-overlay"
                                                    style={{
                                                        position: "fixed",
                                                        top: "80px",
                                                        left: 0,
                                                        width: "100vw",
                                                        height: "100vh",
                                                        backdropFilter: "blur(1px)",
                                                        WebkitBackdropFilter: "blur(6px)",
                                                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                                                        zIndex: 1040
                                                    }}
                                                />
                                                <div className="tooltip-container" target={inputRef.current}>
                                                    <div className="tooltip-message">
                                                        <div className="kareem-tooltip">
                                                            <div className="d-flex">
                                                                <img src={kareem} alt="kareem icon" style={{ cursor: "pointer" }} />
                                                                <div className="ms-3 title">Meet Kareem, your new AI assistant!</div>
                                                            </div>

                                                            <p className="tooltip-body">
                                                                Learn more about how Kareem can help you manage your contract pharmacy program.
                                                            </p>
                                                            <div style={{ textAlign: "right" }}>
                                                                <Button
                                                                    size="sm"
                                                                    type="button"
                                                                    className="btn-text btn btn-primary btn-xs"
                                                                    onClick={() => setShowTooltip(false)}
                                                                >
                                                                    Dismiss
                                                                </Button>
                                                                <Button
                                                                    size="sm"
                                                                    type="button"
                                                                    className="search ms-3 btn btn-primary btn-xs"
                                                                    onClick={tryFeed}
                                                                >
                                                                    Try Now
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    }
 proactive tooltip*/ }
                                    {/* prompts code */}
                                    {/* {
                                        showPrompts && (
                                            <ul className="prompt">
                                                {
                                                    predefinedPrompts.map((item, index) => (
                                                        <li key={index} onClick={() => handlePrompt(index)}>{item}</li>
                                                    ))
                                                }

                                            </ul>
                                        )
                                    } */}
                                </div>
                            </Formik >
                        </div >
                    </footer >
                )
            }


        </>
    );
};

export default ChatbotSearch;
